import { render, staticRenderFns } from "./fav_store.vue?vue&type=template&id=0f7d34be&scoped=true"
import script from "./fav_store.vue?vue&type=script&lang=js"
export * from "./fav_store.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7d34be",
  null
  
)

export default component.exports